import { useContext, useState } from 'react';
import { Grid, Stack, Typography, Paper } from '@mui/material';

import Agents from './Agents';
import UsersList from './UsersList';
import Search from '../UI/search/Search';

import UsersAssignedFilter from './UsersAssignedFilter';

import styles from './Users.module.scss';

import AuthContext from '../../contexts/authContext';

const Users = () => {
  const { planFeatures } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState('');
  const [assignedFilter, setAssignedFilter] = useState('all');

  const { areNetsAgentsAvailable, areAgentsActiveDirectoryAvailable } =
    planFeatures;

  const searchHandler = (e) => {
    setSearchQuery(e.target.value);
  };

  const assignHandler = (e) => {
    setAssignedFilter(e.target.value);
  };

  return (
    <>
      {areNetsAgentsAvailable ? <Agents /> : null}
      {areAgentsActiveDirectoryAvailable ? (
        <Paper>
          <Typography variant="h1" component="h2" sx={{ pb: 3 }}>
            AD agents
          </Typography>
          <Stack
            component="form"
            direction={{ md: 'row' }}
            sx={{ gap: 2 }}
            noValidate
            className={styles['users-control']}
          >
            <Grid item xs={12} md={3}>
              <Search
                placeholder="Users"
                value={searchQuery}
                cb={searchHandler}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <UsersAssignedFilter value={assignedFilter} cb={assignHandler} />
            </Grid>
          </Stack>
          <UsersList
            searchQuery={searchQuery}
            assignedFilter={assignedFilter}
          />
        </Paper>
      ) : null}
    </>
  );
};

export default Users;
